/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
// import * as QrcodeDecoderAll from 'qrcode-decoder';
import qrcodeParser from 'qrcode-parser';

export const decodeFromImage = (img: string) => qrcodeParser(img);
